function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M14.34 10.41a2.252 2.252 0 01-.313 3.445 2.252 2.252 0 11.313-3.445M15.75 15l-1.41-1.41M5.25 9.75h3m-3-3h6"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M14.25 7.5V5.25A2.25 2.25 0 0012 3H4.5a2.25 2.25 0 00-2.25 2.25V12a2.25 2.25 0 002.25 2.25h3.75"
}));